<form class="sign-box reset-password-box">
  <header class="sign-title">Forgot Password</header>
  <p>Please enter your email id and a temporary password will be send to your email.</p>
  <div class="form-group">
    <input type="text" class="form-control" [(ngModel)]="model.email" placeholder="Email" />
  </div>
  <button type="submit" class="btn btn-rounded" (click)="requestPasswordReset()">Submit</button> or <a (click)="goToLogin()">Sign in</a>
</form>
